import { render, staticRenderFns } from "./WhatsAppMessageLogs.vue?vue&type=template&id=19b8353a&scoped=true&"
import script from "./WhatsAppMessageLogs.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessageLogs.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessageLogs.vue?vue&type=style&index=0&id=19b8353a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8353a",
  null
  
)

export default component.exports